<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Adverse Events
      </h2>
      <p class="tw-italic tw-text-gray-700">

      </p>
    </b-container>
    <hr>
      <b-col cols="3">
      <b-form-group
          id="fieldset-1"
          label="Search Subject ID"
          label-for="input-1"
        >
          <b-input-group>
          <b-form-input id="input-1" v-model="search_subject_id" trim v-on:keydown.enter="find"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="find"><i class="fa fa-search"></i></b-button>
          </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    <b-table striped hover :fields="fields" :items="myProvider" :current-page="currentPage"
      :per-page="perPage" :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc" ref="table">
      <template v-slot:cell(dismissed)="data">
        <!-- Only show approve/decline buttons for new requests -->
        <b-button v-if="data.item.dismissed == false" @click="dismiss(data.index)" size="sm" variant="success" class="w-20"><i class="fa fa-check"></i></b-button>
      </template>
      
    </b-table>
    <b-row v-if="totalRows > perPage">
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import * as _ from "lodash";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "ae_sae_date", sortable: true },
        { key: "field_or_clinic", sortable: true },
        { key: "id", label: "Adverse Event Case" },
        { key: "ae_sae_id", label: "AE ID" },
        { key: "dismissed", label: "Dismiss" }
      ],
      perPage: 15,
      totalRows: 1,
      currentPage: 1,
      events: [],
      search_subject_id: null
    };
  },
  computed: {},
  mounted: function() {
    
  },
  methods: {
     ...mapActions('adverseevents', 
            ['getAdverseEventsCount', 'setAdverseEventsCount']),

    refreshSideNavCount(){
      this.getAdverseEventsCount().then((response) => {
                this.setAdverseEventsCount(response.data);
            });
    },
    dismiss: function(index){
      let that = this;
      HTTP.post("/kenya/dismiss_row/", {
        table_name: 'case_ae_sae',
        row_id: that.events[index].id
      }).then(() => {
          that.events.splice(index, 1);
          that.refreshSideNavCount();
      });

    },
    find: function(){
      this.$refs.table.refresh();
    },
    myProvider: function(ctx){
      let that = this;
      let params = {
        current_page: ctx.currentPage,
        per_page: ctx.perPage,
        sort_by: ctx.sortBy,
        descending: ctx.sortDesc
      }
      if(that.search_subject_id != null && that.search_subject_id != ''){
        params.subject_id = that.search_subject_id;
      }
      return HTTP.get("/kenya/adverse_events/get_ae_list", {
        params: params
      }).then(response => {
        let events = [];
        _.each(response.data.cases, function(item){
          if(item.dismissed == false){
            events.push(item);
          }
        });
        that.totalRows = response.data.totalRows;
        return events;
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    }
  }
};
</script>

<style>
</style>